import React from 'react';
import { Link } from 'react-router-dom';
import { links } from './links';

const LandingFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="cf-footer">
      <div className="cf-container">
        <div className="cf-footer__top">
          <Link to={links.home} className="cf-footer__logo">
            <img src="/Image/CricFight_Logo.png" alt="CricFight Logo" />
            <span className="cf-footer__brand">Cric<span>Fight</span></span>
          </Link>
          <p className="cf-footer__about">
            The 100% free cricket app for live scores, scorecards, and tournaments.
          </p>
          <div className="cf-footer__social">
            <a href="https://www.instagram.com/cricfight_official" target="_blank" rel="noopener noreferrer" aria-label="CricFight on Instagram">
              <svg fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
              </svg>
            </a>
            <a href="https://www.trustpilot.com/review/www.cricfight.in" target="_blank" rel="noopener noreferrer" aria-label="Review CricFight on Trustpilot">
              <svg fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 1.5l2.917 6.91 7.083.59-5.4 4.66 1.65 6.84L12 17.65 5.75 20.5l1.65-6.84-5.4-4.66 7.083-.59z" />
              </svg>
            </a>
          </div>
        </div>

        <div className="cf-footer__links">
          <div className="cf-footer__col">
            <h3 className="cf-footer__heading">Explore</h3>
            <a href="#features">Features</a>
            <a href="#how-it-works">How It Works</a>
            <a href="#faq">FAQ</a>
          </div>
          <div className="cf-footer__col">
            <h3 className="cf-footer__heading">Company</h3>
            <a href={links.about}>About Us</a>
            <Link to={links.contact}>Contact</Link>
            <a href={links.privacy}>Privacy Policy</a>
            <a href={links.terms}>Terms &amp; Conditions</a>
          </div>
        </div>

        <div className="cf-footer__bottom">
          <p className="cf-footer__copy">&copy; {currentYear} CricFight. All rights reserved.</p>
          <p className="cf-footer__made">Made with <span>❤️</span> for Cricket</p>
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;
